import { createFileRoute } from '@tanstack/react-router'
import FlashcardGenerator from '@/components/studentPage/FlashcardGenerator'
import { guardStudentOnly } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/flashcards')({
  beforeLoad: guardStudentOnly,
  component: FlashcardsPage,
})

function FlashcardsPage() {
  console.log('Rendering FlashcardsPage component')
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <FlashcardGenerator />
    </div>
  )
}
